import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";
import MiniStatistics from "components/card/MiniStatistics";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

import img from 'assets/img/avatars/avater.jpeg'
export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' justifyContent='center'  direction='column'>
      <img src={img} style={{width: '150px',
    borderRadius: '50%',
    marginBottom:'15px'}}
/>
<h3>Bekkar Merwan</h3>
<h6>Surgery</h6>         
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
